import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from 'material-ui/CircularProgress';

import { getVessels } from 'actions/vessels/vessels';
import styles from 'styles';

import VesselListTable from './Table';

class VesselListPage extends React.Component {
    UNSAFE_componentWillMount() {
        const { vessels } = this.props;

        this.props.getVessels({
            page: vessels.page,
            limit: vessels.limit,
            notConfirmed: vessels.notConfirmed,
            isNameSuggestion: vessels.isNameSuggestion,
        });
    }

    render() {
        const { isLoaded } = this.props;

        return (
            <div id='vessel-list' className='table-page'>
                <CircularProgress className={!isLoaded ? '' : 'hidden'} style={styles.circularProgress} />

                <div className={isLoaded ? '' : 'hidden'}>
                    <div className='container-fluid'>
                        <h2>
                            Vessels
                        </h2>
                        <VesselListTable />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ user: { isLogged }, vessels  }) => ({
        isLogged,
        vessels,
        isLoaded: vessels.isLoaded,
    }),
    dispatch => bindActionCreators( 
        {
            getVessels,
        },
        dispatch,
    ),
)(VesselListPage);



// WEBPACK FOOTER //
// ./app/components/Vessels/List/Page.jsx